const Fonts = {
  familyVerlag: "Verlag",
  familyRalewayLight: "Raleway-Light",
  familyRalewayBold: "Raleway-Bold",
  familyHelveticaLight: "Helvetica",
  familyHelveticaBold: "Helvetica-Bold",
};

export default Fonts;